'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$scope', 'AuditService',
    function ($scope, AuditService) {
    $scope.actions = [];

    AuditService.api.actions(null, (data) => $scope.actions = [{
        id: null,
        name: null,
        description: "<Все>"
    }].concat(data._embedded));

}];
